(ns cljsjs.pikaday
  (:require ["pikaday/pikaday.js" :as pikaday]))

(js/goog.exportSymbol "Pikaday" pikaday)
